export function panelId(label) {
    return `accordion-panel-${label.replace(/\s+/g, '-').toLowerCase()}`;
}
